import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const  GageClickModal = (props) => {

    const [show, setShow] = useState(props.showGageModal);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        
        <Modal className="gageModal" centered show={show} onHide={handleClose}>
            <Modal.Body className="gageModalBody">

                <p className="gageModalContent">
                    Welcome to the City of Roanoke Real Time Flood Inundation Application!  Click the Roanoke River Gage at Walnut Ave (symbolized on the map by the large colored circle) to get started.  
                </p>


            </Modal.Body>
        </Modal>

    )
}


export default GageClickModal;


// WEBPACK FOOTER //
// ./src/components/GageClickModal/index.js